import { forwardRef } from "react";
import { MaskedInput, type MaskedInputProps } from "./MaskedInput";
import { formatCpf } from "../../lib/format";

export type CpfInputProps = Omit<MaskedInputProps, "mask">;

export const CpfInput = forwardRef<HTMLInputElement, CpfInputProps>(
  function CpfInput(props, ref) {
    return (
      <MaskedInput
        ref={ref}
        inputMode="numeric"
        autoComplete="off"
        placeholder="000.000.000-00"
        mask={formatCpf}
        {...props}
      />
    );
  }
);
